import { render } from "./CgtDisposals.vue?vue&type=template&id=d7fc71be&scoped=true"
import script from "./CgtDisposals.vue?vue&type=script&lang=js"
export * from "./CgtDisposals.vue?vue&type=script&lang=js"

import "./CgtDisposals.vue?vue&type=style&index=0&id=d7fc71be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7fc71be"]])

export default __exports__